import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { AuthApi, AuthQueryKey, UnauthApi, UnauthQueryKey } from '@/api';
import { InfiniteListWithMoreButton } from '@/app/donation/_components/InfiniteListWithMoreButton';
import { DONATION_ROUTES } from '@/constants';
import { useWebviewTypeEntry } from '@/hooks/useWebviewTypeEntry';
import { useAuthStore } from '@/stores/AuthStore';
import { BenefitCard } from '../BenefitCard';
import { InfiniteListMoreButton } from '../InfiniteListMoreButton';
import { SectionTitle } from '../SectionTitle';
interface BenefitsContentProps {
  institutionId: number;
}
const PAGE_SIZE = 10;
export const BenefitsContent = t0 => {
  const $ = _c(16);
  const {
    institutionId
  } = t0;
  const isLogin = useAuthStore(_temp);
  const {
    entry
  } = useWebviewTypeEntry();
  let t1;
  if ($[0] !== entry || $[1] !== institutionId) {
    t1 = [institutionId, PAGE_SIZE, entry];
    $[0] = entry;
    $[1] = institutionId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const commonQueryKey = t1;
  let t2;
  if ($[3] !== commonQueryKey || $[4] !== isLogin) {
    t2 = [commonQueryKey, ...(isLogin ? AuthQueryKey["get:/wello/v2/auth/home/institution-event"]() : UnauthQueryKey["get:/wello/v2/allows/home/institution-event"]())];
    $[3] = commonQueryKey;
    $[4] = isLogin;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const queryKey = t2;
  const queryFn = isLogin ? AuthApi["get:/wello/v2/auth/home/institution-event"] : UnauthApi["get:/wello/v2/allows/home/institution-event"];
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SectionTitle className={cn("mb-20", "mobile-tablet:mb-12")}>혜택</SectionTitle>;
    t4 = cn("flex flex-col gap-20", "mobile-tablet:gap-12");
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <InfiniteListMoreButton className={cn("mt-16", "mobile-tablet:mt-0")} />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== entry || $[10] !== institutionId || $[11] !== queryFn) {
    t6 = t7 => {
      const {
        pageParam
      } = t7;
      return queryFn({
        query: {
          institutionId,
          page: pageParam,
          size: PAGE_SIZE,
          entry,
          excludeEndedYN: true
        }
      }).then(_temp2);
    };
    $[9] = entry;
    $[10] = institutionId;
    $[11] = queryFn;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== queryKey || $[14] !== t6) {
    t7 = <div>{t3}<div className={t4}><InfiniteListWithMoreButton moreButtonComponent={t5} queryKey={queryKey} queryFn={t6} pageSize={PAGE_SIZE} renderItem={_temp3} getItemKey={_temp4} /></div></div>;
    $[13] = queryKey;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
function _temp(state) {
  return state.isLogin;
}
function _temp2(data) {
  return data.data?.context?.contents ?? [];
}
function _temp3(item, index) {
  return <BenefitCard title={item.title} bannerUrl={item.bannerImageUrl} pcBannerUrl={item.pcBannerImageUrl} href={DONATION_ROUTES.MY_ETC_EVENT_DETAIL.pathname({
    eventId: item.eventId
  })} priority={index < 2} />;
}
function _temp4(item_0) {
  return item_0.eventId;
}